import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { Box, Button, Typography } from '@mui/material'

import useSharedStyles from '../../../utils/shared.styles'

import useStyles from './activation-details.styles'

interface IProps {
  activationApp: string | undefined
  gps: string | undefined
}

const ActivationDetails = (props: IProps) => {
  const { activationApp, gps } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles

  let parsedGps: IGpsMetadata | null = null

  try {
    parsedGps = typeof gps === 'string' ? JSON.parse(gps) : gps
  } catch {
    parsedGps = null
  }

  const hasGps = activationApp !== 'Central' && parsedGps && (parsedGps.lat || parsedGps.lat === 0) && (parsedGps.long || parsedGps.long === 0)
  const gpsLink = hasGps ? `https://maps.google.com/?q=${parsedGps?.lat},${parsedGps?.long}` : ''

  return (
    <Typography variant="body1">
      <Box component="span" sx={[sharedClasses.centerContentVertical, { display: 'inline-flex', gap: 1 }]}>
        {activationApp && <Box component="span">{activationApp}</Box>}

        {!hasGps && (
          <Box component="span" sx={[sharedClasses.centerContentVertical, { display: 'inline-flex', gap: 0.5 }]}>
            <LocationOffOutlinedIcon sx={classes.locationOffIcon} />
            <Box component="span" sx={sharedClasses.secondaryText}>
              No GPS Location
            </Box>
          </Box>
        )}

        {hasGps && (
          <Button variant="text" component="a" href={gpsLink} target="_blank" rel="noopener noreferrer" sx={classes.gpsButton}>
            <LocationOnOutlinedIcon sx={classes.locationIcon} />
            GPS Location
          </Button>
        )}
      </Box>
    </Typography>
  )
}

export default ActivationDetails
